var $54b47fc030b7b21e$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    const videoIntro = document.querySelector(".video-intro");
    const mainContent = document.querySelector(".main-content");
    const introVideo = document.getElementById("intro-video");
    // Événement : quand la vidéo d’intro se termine
    introVideo.addEventListener("ended", ()=>{
        endIntro();
    });
    // Sécurité : cacher l'intro après 5 secondes max
    setTimeout(()=>{
        endIntro();
    }, 5000);
    function endIntro() {
        videoIntro.style.opacity = "0"; // Effet de fondu
        setTimeout(()=>{
            videoIntro.style.display = "none"; // Cache l'intro
            mainContent.style.display = "block"; // Affiche le contenu principal
            document.body.style.overflow = "auto"; // Active le scroll
        }, 1000);
    }
});
$(document).ready(function() {
    // Swiper: Slider
    new Swiper(".swiper-container", {
        loop: true,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    });
});


//# sourceMappingURL=index.eb142722.js.map
